import { OperationVariables, ApolloQueryResult } from '@apollo/client'

import { ComLog, ComlogData } from '../../../types/monitoring'
import MonitoringFormListRowDesktop from './MonitoringFormListRowDesktop'
import MonitoringFormListRowSkeleton from './MonitoringFormListRowSkeleton.skeleton'
import MonitoringFormListTableHeadDesktop from './MonitoringFormListTableHeadDesktop'

interface MonitoringFormListDesktopProps {
  listData: ComLog[] | undefined
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      comLogs: ComlogData
    }>
  >
  loading: boolean
}

const MonitoringFormListDesktop: React.FC<MonitoringFormListDesktopProps> = ({
  listData,
  refetch,
  loading
}) => {
  return (
    <div>
      <MonitoringFormListTableHeadDesktop refetch={refetch} />
      {!loading && listData
        ? listData.map((item, index) => (
            <MonitoringFormListRowDesktop
              data={item}
              key={item.Id + index.toString()}
            />
          ))
        : Array(8)
            .fill(null)
            .map((_, index) => (
              <MonitoringFormListRowSkeleton key={index.toString()} />
            ))}
    </div>
  )
}
export default MonitoringFormListDesktop
